module.exports = __webpack_public_path__ + "img/44.9202f28a.jpg";